import React from "react";
import {
  FaFileExcel,
  FaFileWord,
  FaFilePdf,
  FaFileAlt,
  FaFilePowerpoint,
  FaFileImage,
} from "react-icons/fa";

const fileIconSize = 75;
const getFileIcon = (extension) => {
  switch (extension) {
    // Excel file types
    case "xlsx":
    case "xlsm":
    case "xltx":
    case "xltm":
    case "xlsb":
    case "xla":
    case "xlam":
    case "csv":
    case "ods":
    case "sml":
    case "dif":
    case "prn":
    case "slk":
    case "xls":
      return <FaFileExcel style={{ color: "#218380" }} size={fileIconSize} />;

    // Word file types
    case "docx":
    case "dot":
    case "dotx":
    case "docm":
    case "dotm":
    case "rtf":
    case "odt":
    case "wsp":
    case "doc":
      return <FaFileWord style={{ color: "#1982c4" }} size={fileIconSize} />;

    // PDF file types
    case "pdf":
    case "pdfa":
    case "pdfx":
    case "xfdf":
    case "fdf":
    case "xps":
    case "eps":
    case "ps":
    case "ppdf":
      return <FaFilePdf style={{ color: "#d81159" }} size={fileIconSize} />;

    // PowerPoint file types
    case "ppt":
    case "pptx":
    case "pps":
    case "ppsx":
    case "pot":
    case "potx":
    case "odp":
      return (
        <FaFilePowerpoint style={{ color: "#ff9f1c" }} size={fileIconSize} />
      );

    // Image file types
    case "jpeg":
    case "jpg":
    case "png":
    case "gif":
    case "bmp":
    case "tiff":
    case "svg":
    case "webp":
      return <FaFileImage style={{ color: "#ffbf69" }} size={fileIconSize} />;

    // Default for unrecognized file types
    default:
      return <FaFileAlt style={{ color: "gray" }} size={fileIconSize} />;
  }
};
export default function FileIcon({fileExtension}) {
  const fileIcon = getFileIcon(fileExtension);

  return fileIcon;
}
